import gql from "graphql-tag";

/**
 * QA-IMPERSONATION — the technician picker.
 *
 * Active, non-virtual technicians only. Markets are derived from what comes back
 * rather than from the market enum, so the picker can never offer a market with
 * nobody in it.
 */
export const GET_TECHNICIANS = gql`
  query getTechnicians($filter: JSON) {
    getTechnicians(filter: $filter) {
      id
      firstName
      lastName
      market
    }
  }
`;
